import Grid from '@mui/material/Grid';
import { Button, Typography } from '@mui/material';
import { CustomField } from '../../GeneratedClient';
import { CustomFieldsFilter } from '../../Generic/CustomFieldsFilter/CustomFieldsFilter';
import {
  CustomFieldFilterOption,
  CustomFieldFilterSelectionsByField,
  CustomFieldFilterValue,
} from '../../Generic/CustomFieldsFilter/types';

type Props = {
  customFields: CustomField[];
  getOptionsForField: (field: CustomField) => CustomFieldFilterOption[];
  selectedValuesByField: CustomFieldFilterSelectionsByField;
  onFieldChange: (
    fieldName: string,
    selectedValues: CustomFieldFilterValue[]
  ) => void;
  onClose: () => void;
};

export function VolunteerCustomFieldFiltersSidePanel({
  customFields,
  getOptionsForField,
  selectedValuesByField,
  onFieldChange,
  onClose,
}: Props) {
  return (
    <Grid
      container
      spacing={2}
      sx={{ maxWidth: 500, paddingBottom: { xs: 10, sm: 4 } }}
    >
      <Grid size={12}>
        <h3>Custom Field Filters</h3>
        <Typography>
          Select one or more values for each custom field to narrow the
          volunteer list.
        </Typography>
      </Grid>

      <Grid size={12}>
        <CustomFieldsFilter
          customFields={customFields}
          getOptionsForField={getOptionsForField}
          selectedValuesByField={selectedValuesByField}
          onFieldChange={onFieldChange}
          direction="column"
          fullWidthSelects
        />
      </Grid>

      <Grid size={12} sx={{ textAlign: 'right' }}>
        <Button color="secondary" variant="contained" onClick={onClose}>
          Close
        </Button>
      </Grid>
    </Grid>
  );
}
